function addClassNameSorting(renderer) {
  var existingRenderRule = renderer.renderRule.bind(renderer);

  renderer.renderRule = function () {
    var className = existingRenderRule.apply(undefined, arguments);
    return className.split(/\s+/g).sort(function (a, b) {
      return a < b ? -1 : a > b ? +1 : 0;
    }).join(' ');
  };

  return renderer;
}
/* eslint-disable no-console */


export default function sortClassNames() {
  return addClassNameSorting;
}